module.exports = __webpack_public_path__ + "static/media/400x400-AYCM-DokiApp-banner.4db6f8e3.png";